import { useEffect, useState, useContext } from "react";
import { GTIWebSnackbar ,  Grid , GTIWebButton } from "@gti-controls-v2/web-core";
import { SettingsContext } from "../../../providers/settings";
import ModalEditData from "./modalEditData"
import useModal from "../../../hooks/useModal";
import useUsers from "../../../hooks/useUsers";
import SecurityStyles from "../../../common/styles/Security";
import StatusList from "../../../components/card-panel";

const Security = ({ user, employee , TicketID, onDataUpdate }) => {
    const MOLDE_EMAIL_PASSWORD = 2;
    const [alerta, setAlerta] = useState(false);
    const [tipoAlerta, setTipoAlerta] = useState("success");
    const [mensajeAlerta, setMensajeAlerta] = useState("");
    const { handleLoading } = useContext(SettingsContext);
    const { isShowing, open, close } = useModal();
    const { enviaEmailRestablecer , enviaSMSRestablecer } = useUsers();
    const [nip, setNip] = useState("");
    const [emailRD, setEmailRD] = useState("");
    const [phone, setPhone] = useState("");
    const [phoneStatus, setPhoneStatus] = useState(1);
    const [email, setEmail] = useState("");
    const [emailStatus, setEmailStatus] = useState(1);
    const [secretQuestion, setSecretQuestion] = useState();
    const [disabledEdit, setDisabledEdit] = useState(false)

    const typeAction  = {
        sendCorreo: 'sendcorreo',
        sendCelular: 'sendcelular'
    };
    const contactStatus  = {
        UnVerified: 1,
        Verified: 2
    };


    useEffect(() => {
        if (employee) {
            setEmailRD(employee.AutoUserEmail);
            setNip(employee.AutoUserNIP);
        }
        
        if (Object.keys(user).length > 0) {
            setPhone(user?.UsuarioCelular ?? null);
            setEmail(user?.UsuarioEmail ?? null);
            setPhoneStatus(user?.UsuarioCelStatus ?? null);
            setEmailStatus(user?.UsuarioEmailStatus ?? null)
            setSecretQuestion(user?.UsuarioPreguntaDesc ?? null);
            setDisabledEdit(false);
        }else
        {
            setDisabledEdit(true);
        }
    }, [user, employee, phone, email]);

    const onResetPassword = async (e, typeName) => {
        if (typeName === typeAction.sendCorreo) {
            if (emailStatus === contactStatus.Verified) {
                const resultResetPassword = await enviaEmailRestablecer(user.UsuarioID, TicketID, email, MOLDE_EMAIL_PASSWORD);
                if (resultResetPassword.exitoso) {
                    setMensajeAlerta("El enlace para reactivación de contraseña fue enviado correctamente vía correo electrónico");
                    setTipoAlerta("success");
                    setAlerta(true);
                }else
                {
                    if(!email)
                    {
                        setMensajeAlerta(errorRevision(resultResetPassword,"No se puede enviar el enlace para restablecer la contraseña porque el usuario no tiene un correo electrónico registrado."));
                        setTipoAlerta("error");
                        setAlerta(true);

                    }else
                    {
                        setMensajeAlerta(errorRevision(resultResetPassword,"Ocurrió un error al Enviar correo"));
                        setTipoAlerta("error");
                        setAlerta(true);
                    }
                }
            } else {
                setMensajeAlerta("No se puede enviar el enlace de reactivación de contraseña porque el correo no está verificado");
                setTipoAlerta("error");
                setAlerta(true);
            }
        }
    
        if (typeName === typeAction.sendCelular) {
            if (phoneStatus === contactStatus.Verified) {
                const resultResetPassword = await enviaSMSRestablecer(user.UsuarioID, TicketID, phone, user.UsuarioLogin);
                if (resultResetPassword.exitoso) {
                    setMensajeAlerta("El enlace para reactivación de contraseña fue enviado correctamente vía WhatsApp");
                    setTipoAlerta("success");
                    setAlerta(true);
                }else
                {
                    if(!phone)
                    {
                        setMensajeAlerta(errorRevision(resultResetPassword,"No se puede enviar el enlace para restablecer la contraseña porque el usuario no tiene un número de teléfono registrado."));
                        setTipoAlerta("error");
                        setAlerta(true);

                    }else
                    {
                        setMensajeAlerta( errorRevision(resultResetPassword,"Ocurrió un error al Enviar SMS."));
                        setTipoAlerta("error");
                        setAlerta(true);
                    }
                }
            } else {
                setMensajeAlerta("No se puede enviar el enlace de reactivación de contraseña porque el teléfono no está verificado");
                setTipoAlerta("error");
                setAlerta(true);
            }
        }
    };
    

    const onModalClosed = () => {
        handleLoading(true);
        close();
        handleLoading(false);
    };


    const errorRevision = (error, mensajeDefault) => {
        let mensaje = {}; 
        if (error.data?.detalle?.internos?.length > 0) {
            mensaje = error.data.detalle.internos[0];
            return `${mensaje.codigo} ${mensaje.nombre}`;
        } else if (error.data?.detalle?.errores?.length > 0) {
            mensaje = error.data.detalle.errores[0];
            return `${mensaje.codigo} ${mensaje.nombre}`;
        } else {
            return mensajeDefault;
        }
    };

    return (
        <Grid container spacing={2} paddingTop={4}>
            <GTIWebSnackbar
                key={"alerta"}
                open={alerta}
                severity={tipoAlerta}
                message={mensajeAlerta}
                onClose={() => setAlerta(false)}
            />
            
            <ModalEditData 
                open={isShowing}
                onClose={onModalClosed}
                phone={phone}
                email={email}
                ticketID={TicketID}
                username={user?.UsuarioLogin}
                onDataUpdate={onDataUpdate}
            />

            <Grid item xs={1} md={2022} >

            <StatusList handleClick={onResetPassword} dataSet={[
                        { label: "Teléfono celular ", value: phone, status: (phoneStatus === contactStatus.Verified), button: "Enviar enlace", buttonId:typeAction.sendCelular},
                        { label: "Correo principal ", value: email, status: (emailStatus === contactStatus.Verified), button: "Enviar enlace", buttonId:typeAction.sendCorreo }
                    ]}/>
                       <div style={{paddingTop:10 , paddingBottom:10}}>
                            <GTIWebButton
                                name="Modificar"
                                type="submit"
                                text="Modificar"
                                disabled={disabledEdit}
                                sx={SecurityStyles.btnContinue}
                                onClick={() => { open();}}
                            />
                        </div>
                          

                    <StatusList  dataSet={[
                        { label: "Pregunta Secreta", value: secretQuestion },
                        { label: "Correo recibo digital", value: emailRD },
                        { label: "NIP", value: nip }
                    ]}/>
             </Grid>
        </Grid>
    );
};
  
export default Security;